import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { faEye, faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SocialSecurityService } from 'src/app/pages/privado/services/previdencia/social-security.service';
import { ContributionFilter } from 'src/app/shared/classe/contribution-filter.model';
import { ModalDetalheAporteComponent } from 'src/app/shared/modals/modal-detalhe-aporte/modal-detalhe-aporte.component';
@Component({
  selector: 'app-minhas-solicitacoes-aporte',
  templateUrl: './minhas-solicitacoes-aporte.component.html',
  styleUrls: ['./minhas-solicitacoes-aporte.component.css']
})
export class MinhasSolicitacoesAporteComponent {
  loadingPdf: boolean = false;
  loadingCsv: boolean = false;
  //Icones    
  faPdf = faFilePdf;
  faExcel = faFileExcel;
  faEye = faEye;
  today = new Date();
  loading: boolean = true;
  downloading: boolean = false;
  lista: any;
  myContributionRequests: any;
  formGroup: FormGroup = new FormGroup({
    finalDate: new FormControl(null),
    initialDate: new FormControl(null),
    itemsPerPage: new FormControl(5),
    page: new FormControl(0),
    totalFiltered: new FormControl(),
  });
  constructor(private socialSecurityService: SocialSecurityService, private modalService: NgbModal) {
    this.load();
  }
  load() {
    this.loading = true;
    this.socialSecurityService.getIntakes(this.formGroup.value).subscribe((res: any) => {
      this.myContributionRequests = res.items;
      this.loading = false;
      this.formGroup.patchValue(res);
      this.lista = res;
    })
  }
  printCsv() {
    let contributionFilter = new ContributionFilter(0, 0, this.formGroup.value.initialDate, this.formGroup.value.finalDate, 'aportes');
    this.socialSecurityService.getContributionsCsv(contributionFilter).subscribe(
      (data: Blob) => {
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "Extrato de Aportes.csv";
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      });
  }
  visualizarAporte(details: any) {
    const modalRef = this.modalService.open(ModalDetalheAporteComponent, { windowClass: 'carteirinha-modal-size', centered: true });
    modalRef.componentInstance.details = details;
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.formGroup.get('itemsPerPage')?.setValue(quantidade);
    this.formGroup.get('page')?.setValue(0);
    this.socialSecurityService.getIntakes(this.formGroup.value).subscribe((res: any) => {
      this.myContributionRequests = res.items;
      this.loading = false;
      this.formGroup.patchValue(res);
    })
  }
  onChangePagination(page: number) {
    this.formGroup.get('page')?.setValue(page);
    this.socialSecurityService.getIntakes(this.formGroup.value).subscribe((res: any) => {
      this.myContributionRequests = res.items;
      this.loading = false;
    })
  }
}
